export default __webpack_public_path__ + "static/yo-fro-strawberry-7a31c6d80616986c33f12c2029beffb4.png";